import type { BillingTier } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Label } from '~/components/ui/label'
import { BILLING_TIERS } from '~/helpers/billing/billing-tiers'

type Props = {
  value: BillingTier
  onChange: (tier: BillingTier) => void
}

/**
 * Formule souscrite d'une organisation (#165). Tant que l'achat en ligne est
 * coupé, c'est ici, et seulement ici, qu'un client passe au payant.
 */
function OrganizationPlanField({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="space-y-2">
      <Label htmlFor="org-tier">{t('organization.edit.tier')}</Label>
      <select
        id="org-tier"
        value={value}
        onChange={e => onChange(e.target.value as BillingTier)}
        aria-describedby="org-tier-help"
        className="h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm"
      >
        {BILLING_TIERS.map(tier => (
          <option key={tier} value={tier}>{t(`billing.tier.${tier}`)}</option>
        ))}
      </select>
      <p id="org-tier-help" className="text-xs text-muted-foreground">{t(`billing.tier.${value}.help`)}</p>
    </div>
  )
}

export default OrganizationPlanField
